import React from 'react';
import { Zap, Scissors, ShieldCheck } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-[#0a0e27] relative" data-id="element-218">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-yellow-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-219"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-220">
        <div className="text-center mb-16" data-id="element-221">
          <span className="text-yellow-400 font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-222">
            El Mecanismo Único
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-223">
            El Método de{' '}
            <span className="bg-gradient-to-r from-yellow-200 to-yellow-500 bg-clip-text text-transparent" data-id="element-224">
              Tríada Relámpago
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-225">
            Este sistema no se basa en teorías, sino en una intervención técnica
            de 72 horas dividida en tres fases obligatorias para erradicar el
            problema de raíz.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-226">
          {/* Day 1 */}
          <div className="relative group" data-id="element-227">
            <div className="absolute inset-0 bg-gradient-to-b from-yellow-500/20 to-transparent rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-228"></div>
            <div className="relative h-full bg-[#1a1f3a] border border-white/10 rounded-3xl p-8 hover:border-yellow-500/30 transition-colors z-10 flex flex-col" data-id="element-229">
              <div className="text-yellow-500 font-black text-6xl opacity-20 absolute top-6 right-6" data-id="element-230">
                01
              </div>
              <div className="w-14 h-14 bg-yellow-500/10 rounded-2xl flex items-center justify-center mb-6 border border-yellow-500/20" data-id="element-231">
                <Zap className="w-7 h-7 text-yellow-400" data-id="element-232" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-233">Día 1</h3>
              <h4 className="text-lg text-yellow-400 font-semibold mb-4" data-id="element-234">
                Diagnóstico y Purga
              </h4>
              <p className="text-gray-400 leading-relaxed flex-1" data-id="element-235">
                Identificas exactamente qué tipo de energía o entidad te está
                afectando y realizas el protocolo de extracción profunda para
                sacarlo de tu sistema físico y etérico.
              </p>
            </div>
          </div>

          {/* Day 2 */}
          <div className="relative group" data-id="element-236">
            <div className="absolute inset-0 bg-gradient-to-b from-yellow-500/20 to-transparent rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-237"></div>
            <div className="relative h-full bg-[#1a1f3a] border border-white/10 rounded-3xl p-8 hover:border-yellow-500/30 transition-colors z-10 flex flex-col" data-id="element-238">
              <div className="text-yellow-500 font-black text-6xl opacity-20 absolute top-6 right-6" data-id="element-239">
                02
              </div>
              <div className="w-14 h-14 bg-yellow-500/10 rounded-2xl flex items-center justify-center mb-6 border border-yellow-500/20" data-id="element-240">
                <Scissors className="w-7 h-7 text-yellow-400" data-id="element-241" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-242">Día 2</h3>
              <h4 className="text-lg text-yellow-400 font-semibold mb-4" data-id="element-243">
                Corte de Lazos
              </h4>
              <p className="text-gray-400 leading-relaxed flex-1" data-id="element-244">
                Desconectas los cordones energéticos invisibles que te atan a
                personas tóxicas, vampiros energéticos o entidades que se
                alimentan de tu vitalidad.
              </p>
            </div>
          </div>

          {/* Day 3 */}
          <div className="relative group" data-id="element-245">
            <div className="absolute inset-0 bg-gradient-to-b from-yellow-500/20 to-transparent rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-246"></div>
            <div className="relative h-full bg-[#1a1f3a] border border-white/10 rounded-3xl p-8 hover:border-yellow-500/30 transition-colors z-10 flex flex-col" data-id="element-247">
              <div className="text-yellow-500 font-black text-6xl opacity-20 absolute top-6 right-6" data-id="element-248">
                03
              </div>
              <div className="w-14 h-14 bg-yellow-500/10 rounded-2xl flex items-center justify-center mb-6 border border-yellow-500/20" data-id="element-249">
                <ShieldCheck className="w-7 h-7 text-yellow-400" data-id="element-250" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-251">Día 3</h3>
              <h4 className="text-lg text-yellow-400 font-semibold mb-4" data-id="element-252">
                Sellado de Blindaje
              </h4>
              <p className="text-gray-400 leading-relaxed flex-1" data-id="element-253">
                Creas un escudo protector impenetrable que sella tu aura,
                haciéndote "invisible" ante nuevas proyecciones de envidia,
                maldad o ataques psíquicos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}